import { getReferenceRoomUrl } from '@/service/dashboard/getReferenceRoomUrl';

/**
 * ヘッダ
 * @param {*} $scope
 * @param {*} $state
 * @param {*} $interval
 * @param {*} Push
 * @param {*} agenciesService
 * @param {*} facilityService
 * @param {*} tutorialService
 */
function headerCtrl($scope, $state, $interval, Push, agenciesService, facilityService, tutorialService) {
  // サービス切り替え時の処理
  $scope.$on('serviceChanged', function (event, data) {
    $scope.initial();
  });

  $scope.initial = () => {
    // 自身の設定を取得
    $scope.getMine().then(function () {
      // サービス設定を取得
      var service_id = $scope.my.current_service_id ? $scope.my.current_service_id : $scope.my.service_id;
      $scope.getService(service_id).then(function () {
        $scope.logoImageFileName = getLogoImageFileName();
        // 連絡受付機能を使用する
        if (
          $scope.services &&
          $scope.services.attributes &&
          $scope.services.attributes.contact_use == $scope.system.FLAG_ON.toString()
        ) {
          Push.Permission.request(
            function () {
              // eslint-disable-next-line
              if (!$scope.getSize(globalNotifyTimer)) {
                // 初回のデータを取得
                if ($scope.getDevice() == $scope.system.DEVICE_TYPE_OHTER) {
                  $scope.checkNotifications();

                  // 定期処理を設定
                  // eslint-disable-next-line
                  globalNotifyTimer = $interval(function () {
                    $scope.checkNotifications();
                  }, 1000 * 60 * 2);
                }
              }
            },
            function () {
              $scope.cancelNotifyTimer();
            }
          );
        } else {
          $scope.cancelNotifyTimer();
        }


        $scope.setScopeBillsForCheck().then(function () {
          $scope.hasAuthForInquiryFee();

          // 「プランとお支払い」の通知表示
          $scope.notifyLatestBill();
        });

        $scope.isDirectContractFacilities = agenciesService.containsDirectContractFacilities(
          $scope.my.manage_service?.id
        );
      });
    });
  };

  $scope.moveToInquiryFee = function () {
    // 自身の設定を取得
    $scope.getMine(true).then(function () {
      // 権限がなければ、ダッシュボードへ遷移
      $scope.setScopeBillsForCheck().then(function () {
        $scope.hasAuthForInquiryFee();
        if (!$scope.canUseInquiryFee) {
          $scope.noAuthority();
        } else {
          $state.go('inquiry_fee.detail');
        }
      });
    });
  };

  $scope.$on('restartTutorialBroadCast', function () {
    const service_id = $scope.my.current_service_id ? $scope.my.current_service_id : $scope.my.service_id;
    $scope.getService(service_id, true).then(function () {
      tutorialService.setTutorial($scope);
    });
  });

  $scope.goToReferenceRoom = function () {
    location.href = getReferenceRoomUrl();
  };

  $scope.getFacilityPlanName = function () {
    return facilityService.getPlanName();
  };

  const getLogoImageFileName = () => {
    if ($scope.isLgwan()) {
      return 'img/codmon_white_logo.svg';
    } else if ($scope.isL4A()) {
      return 'img/codmon_green_logo.svg';
    } else {
      return 'img/codmon_logo_sub.svg';
    }
  };

  $scope.initial();
}

angular.module('inspinia').controller('headerCtrl', headerCtrl);
